import Vue from 'vue'
import EditorTool from './editorTool.vue'
import UploadTool from './uploadTool.vue'
import DoubleCheckTool from './doubleCheckTool.vue'

Vue.component('editor-tool', EditorTool)
Vue.component('upload-tool', UploadTool)
Vue.component('double-check-tool', DoubleCheckTool)
